import React from "react";
//images
import ImgOne from "../../assets/images/about-us/img-1.webp";
import ImgTwo from "../../assets/images/about-us/img-2.webp";
import ImgThree from "../../assets/images/about-us/img-3.webp";

const AboutCustomers = () => {
  return (
    <article className="about__customers">
      <div className="about__customers_gallery">
        <img src={ImgOne} alt="" aria-hidden="true" />
        <img src={ImgTwo} alt="" aria-hidden="true" />
        <img src={ImgThree} alt="" aria-hidden="true" />
      </div>
      <section className="about__customers__content">
        <h2 className="sub-title">Zufriedene Kunden</h2>
        <h3>Über 8000 positive Rückmeldungen</h3>
        <p>
          Unser Erfolg basiert auf der Leidenschaft für außergewöhnliches Essen und exzellenten Service. Jedes Gericht auf unserer Speisekarte – von handgemachten Pizzen über frische Salate, Gourmet-Sandwiches bis hin zu klassischen Pasta-Gerichten – wird mit **hochwertigen, regionalen Zutaten** zubereitet, um ein perfektes Gleichgewicht aus Geschmack und Frische zu gewährleisten.  
          <br /><br />
          Doch großartiges Essen ist nur ein Teil des Erlebnisses. Wir glauben, dass eine warme, einladende Atmosphäre und echte Gastfreundschaft ein gutes Essen in ein unvergessliches verwandeln. Unser engagiertes Team geht die Extrameile, damit sich jeder Gast wie zu Hause fühlt – und jeder Besuch genauso angenehm ist wie der letzte.  
          <br /><br />
          Bei Casaantonio e Piccolo Giò geht es nicht nur um gutes Essen – es geht darum, Momente zu schaffen, die unsere Gäste immer wieder zurückkommen lassen.
  </p>
      </section>
      <div className="img-glass"></div>
    </article>
  );
}


export default AboutCustomers;